import { Col, Form, Row, Select, Spin } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { getRequest, patchRequest, postRequest } from "../../../axios";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import InputField from "../../../common/htmlComponents/InputField";
import "../../../styles/Main.scss";
import { authUserData } from "../../../utils/Helper";
import {
  SuccessNotificationMsg,
} from "../../../utils/Notifications";

const AddZoneModel = ({
  handleCancel,
  setReload,
  zoneId,
  modalKey,
  setStateM,
}) => {
  const { t } = useTranslation();
  const formRef = useRef();

  const initialState = {
    zone: "",
    country: authUserData()?.country? authUserData()?.country:1,
    state: authUserData()?.state?authUserData()?.state:1,
   
  };
  const [state, setState] = useState(initialState);
  const [country, setCountry] = useState([]);
  const [States, setStates] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);


  const { Option } = Select;

  useEffect(() => {
    getCountryName();
   
    authUserData()?.country?
    getStateByCountry(authUserData()?.country): getStateByCountry(1)

  }, []);
  useEffect(() => {
    const zoneGetById = async () => {
      if (zoneId !== null) {
        try {
          setapiLoading(true);
          const response = await getRequest(`zone/${zoneId}/`);
          if (response.data.success) {
            const {
              id,
              country_name,
              state_name,
              state_code,
              country_code,

              ...filteredResponse
            } = response.data.data;
            setState((prevState) => {
              return {  
                ...filteredResponse,
              };
            });

            formRef.current.setFieldsValue({
              ...response.data.data,
              state: response.data.data.state_name,
              country: response.data.data.country_name,
            });
            getStateByCountry(response?.data?.data?.country);
            setapiLoading(false);
          }
        } catch (error) {
          setapiLoading(false);
        }
      }
    };
    zoneGetById();
  }, [zoneId, modalKey]);


  

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        backToList();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, );

  const getCountryName = async () => {
    try {
      setapiLoading(true);
      const response = await getRequest("country/?no_pagination=True");
    
      const { data } = response.data;

      setCountry(data);
      formRef.current.setFieldsValue(response.data.data);
      setapiLoading(false);
    } catch (error) {
      setapiLoading(false);
    }
  };

  const handleCountrySelectChange = (value) => {
    setState((prevState) => {
      return {
        ...prevState,
        country: value,
        state: null,
      };
    });
    formRef.current.setFieldsValue({ state: null });
    setStates([]);
    getStateByCountry(value);
  };
  const getStateByCountry = async (id) => {
    const stateResponse = await getRequest(
      "state/?no_pagination=true&country_id=" + id
    );

    setStates(stateResponse?.data?.data);
  };

  const handleStateSelectChange = (value) => {
    setState((prevState) => ({
      ...prevState,
      state: value,
    }));
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const backToList = () => {
    setState(initialState);
    formRef.current.setFieldsValue(initialState);
    handleCancel();
  };

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      let response;
      if (zoneId === null) {
        response = await postRequest("zone/", state);
      } else {
        response = await patchRequest(`zone/${zoneId}/`, state);
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          zoneId === null
            ? t("zone_name_added_successfully2")
            : t("zone_name_updated_successfully2")
        );
        setState(initialState);
        setStateM((prev) => ({
          ...prev,
          page: 1,
        }));

        formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        handleCancel();
        setReload((reload) => !reload);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Spin spinning={apiLoading}>
        <Form
          className="ModalForm"
          onFinish={handleSubmit}
          autoComplete="off"
          ref={formRef}
          initialValues={state}
        >
          <Row gutter={16}>
            <Col md={12} className="TextFeild">
              <Form.Item
                name="country"
                label={t("pl_country")}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("val_country")}</Trans>,
                  },
                ]}
              >
                <Select
                 placeholder="Select Country"
                 name="country"
                 value={state.country}
                 showArrow
                 showSearch
                 onChange={handleCountrySelectChange}
                 optionFilterProp="children"
                >
                  {country?.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col md={12} className="TextFeild">
              <Form.Item
                name="state"
                label={t("pl_state")}
                rules={[
                  {
                    required: true,
                    message: <Trans>{t("pl_select_state")}</Trans>,
                  },
                ]}
              >
                <Select
                 name="state"
                 placeholder={t("pl_select_state")}
                 showArrow
                 showSearch
                 value={state.state}
                 onChange={handleStateSelectChange}
                 optionFilterProp="children"
                >
                  {States?.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
          </Row>
          <Col md={24} className="TextFeild">
            <InputField
              name="zone"
              value={state.zone}
              label={t("pl_zone_name")}
              placeholder={t("pl_enter_zone")}
              handleInputChange={handleInputChange}
              rules={t("val_zone_name")}
              pattern={"^[a-zA-Z0-9\\s]+$"}
              max={100}
            />
          </Col>
          <div className="ModalPopupFooter">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("cancel")}
              onClick={backToList}
            />
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="Submit"
              label={t("Save")}
              loading={btnLoading}
            />
          </div>
        </Form>
      </Spin>
    </>
  );
};

AddZoneModel.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  zoneId: PropTypes.number,
  modalKey: PropTypes.bool,
  setStateM: PropTypes.func.isRequired,
};

export default AddZoneModel;
